import { useEffect, useState, useContext } from "react";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { AuthContext } from "../../context/AuthContext";
import { supabase } from "../../supabase";
import "./Payment.css";

const API_BASE = process.env.REACT_APP_API_BASE || "/api";

export default function PaymentSuccess() {
  const { t } = useTranslation();
  const { user, refreshProfile } = useContext(AuthContext);
  const history = useHistory();
  const [status, setStatus] = useState("loading");

  useEffect(() => {
    if (!user?.id) return;

    let cancelled = false;

    async function pollSubscription() {
      for (let i = 0; i < 10; i++) {
        if (cancelled) return;
        try {
          const { data: { session } } = await supabase.auth.getSession();
          if (!session) break;
          const res = await fetch(`${API_BASE}/subscription/status`, {
            headers: { Authorization: `Bearer ${session.access_token}` },
          });
          const data = await res.json();
          if (data.subscription?.status === "active") {
            await refreshProfile();
            setStatus("success");
            return;
          }
        } catch (e) {
          console.error("poll error", e);
        }
        await new Promise((r) => setTimeout(r, 3000));
      }
      if (!cancelled) setStatus("pending");
    }

    pollSubscription();
    return () => { cancelled = true; };
  }, [user?.id]);

  return (
    <div className="payment-result-page">
      <div className="payment-result-card">
        {status === "loading" && (
          <>
            <div className="payment-icon">...</div>
            <h1>{t("payment.processing")}</h1>
            <p>{t("payment.processingDesc")}</p>
          </>
        )}
        {status === "success" && (
          <>
            <div className="payment-icon success">O</div>
            <h1>{t("payment.successTitle")}</h1>
            <p>{t("payment.successMessage")}</p>
            <button className="btn-primary" onClick={() => history.push("/mypage")}>
              {t("nav.mypage")}
            </button>
          </>
        )}
        {status === "pending" && (
          <>
            <div className="payment-icon pending">!</div>
            <h1>{t("payment.pendingTitle")}</h1>
            <p>{t("payment.pendingMessage")}</p>
            <button className="btn-primary" onClick={() => history.push("/mypage")}>
              {t("nav.mypage")}
            </button>
          </>
        )}
      </div>
    </div>
  );
}
